var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"periodicFunctionality"},[_c('period-date-picker',{on:{"getDate":_vm.getFunctionality}}),_c('div',{staticClass:"py-2"},[_c('PeriodWork',{attrs:{"periodWork":_vm.periodWork}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }